var exports = {
  "Nr": "StreamWatchHoverCard.module__card___MzMtVG",
  "Br": "StreamWatchHoverCard.module__variantCompact___MzMtVG",
  "wy": "StreamWatchHoverCard.module__variantList___MzMtVG",
  "VH": "StreamWatchHoverCard.module__preview___MzMtVG",
  "sf": "StreamWatchHoverCard.module__previewCompact___MzMtVG",
  "$8": "StreamWatchHoverCard.module__previewList___MzMtVG",
  "oz": "StreamWatchHoverCard.module__previewImage___MzMtVG",
  "nZ": "StreamWatchHoverCard.module__previewFallback___MzMtVG",
  "SV": "StreamWatchHoverCard.module__compactButtonWrap___MzMtVG",
  "Iq": "StreamWatchHoverCard.module__compactButton___MzMtVG",
  "$l": "StreamWatchHoverCard.module__actionRow___MzMtVG",
  "uu": "StreamWatchHoverCard.module__actionButtons___MzMtVG",
  "jb": "StreamWatchHoverCard.module__listButton___MzMtVG",
  "fX": "StreamWatchHoverCard.module__previewClickable___MzMtVG",
  "FC": "StreamWatchHoverCard.module__previewHoverOverlay___MzMtVG",
  "Mp": "StreamWatchHoverCard.module__previewHoverText___MzMtVG",
  "z0": "StreamWatchHoverCard.module__protipRow___MzMtVG",
  "cm": "StreamWatchHoverCard.module__protipText___MzMtVG",
};

module.exports = exports;
